import { render, staticRenderFns } from "./AssignmentReport.vue?vue&type=template&id=5728f912&scoped=true"
import script from "./AssignmentReport.vue?vue&type=script&lang=js"
export * from "./AssignmentReport.vue?vue&type=script&lang=js"
import style0 from "./AssignmentReport.vue?vue&type=style&index=0&id=5728f912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5728f912",
  null
  
)

export default component.exports